import Vue from 'vue';
import { SerfJob } from '@/model';
import sse, { HandlerRegistration } from '@/sse';

type PropsOfType<T, U> = {
  [K in keyof T]: T[K] extends U ? K : never
}[keyof T];

export default Vue.extend({
  data() {
    return {
      sseRegistration: [] as HandlerRegistration[],
    };
  },
  beforeDestroy() {
    this.sseRegistration.forEach((reg) => reg.unsubscribe());
  },
  methods: {
    subscribeUntil(p: (job: SerfJob) => boolean): Promise<SerfJob> {
      return new Promise<SerfJob>((resolve, reject) => {
        const handler = (event: { job: SerfJob }): boolean => {
          let match;
          try {
            match = p(event.job);
          } catch (err) {
            reject(err);
          }
          if (match) {
            resolve(event.job);
          }
          return match;
        };
        this.sseRegistration.push(sse.subscribe({ type: 'JobStateChanged', handler }));
      });
    },
    subscribe<T>(initial: T[], k: PropsOfType<T, SerfJob | undefined>): T[] {
      const vf = (t: T): SerfJob | undefined => (t as any)[k] as SerfJob | undefined;
      if (initial.map(vf).every((job) => !job?.id || job.stopped)) {
        // no need to listen for events, all jobs are stopped or unidentifiable
        return initial;
      }
      const result = [...initial];
      const handler = (event: { job: SerfJob }): boolean => {
        let anyWaiting = false;
        for (let i = 0; i < result.length; i++) {
          const stale = vf(result[i]);
          if (stale?.id === event.job.id) {
            Vue.set(result, i, { ...result[i], [k]: event.job } as T);
            anyWaiting = anyWaiting || !event.job.stopped;
          } else {
            anyWaiting = anyWaiting || (!!stale && !stale.stopped);
          }
        }
        return !anyWaiting;
      };
      this.sseRegistration.push(sse.subscribe({ type: 'JobStateChanged', handler }));
      return result;
    },
  },
});
